// @flow
import * as React from 'react';

require('./style.scss');
import roundedTriangleWhite from "kiosk/wayfinding/assets/roundedtrianglewhite.svg";
import AnimateHeight from 'react-animate-height';
import loadingClock from 'kiosk/wayfinding/assets/loading-clock.svg';

type Props = {
    active: boolean,
    onHeaderClick: ()=>void,
    children?: React.Node,
    title: string,
};

type State = {
    expanded: boolean,
};

export class ExpandableListItem extends React.Component<Props, State> {

    _scrollIntoView = () => {
        if( this.props.active ){
            this.refs['invisible-scroll-anchor'].scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }

    render() {
        const {
            active,
            children,
            title,
        } = this.props;

        if(this.props.active){
            setTimeout(this._scrollIntoView, 1);
            setTimeout( this._scrollIntoView, 500);
        }


        return <div className={`expandable-list-item`} >
            <span ref="invisible-scroll-anchor" style={{position:'absolute', top: '-30px'}}></span>
            <span className='accent-color' />
            <div className="clickable-header" onClick={this.props.onHeaderClick}>
                <div className="info-text-container">
                    <h3 className="title">
                        <span>{title}</span>
                    </h3>
                    
                </div>
                <img className="expanded-status-icon" width="30px"
                    style={ {
                        opacity: 0.8,
                        transform: `${active ? 'rotate(180deg)' : 'rotate(90deg)'} scaleY(1.4)`
                    } }
                    src={roundedTriangleWhite}
                />

            </div>
            <AnimateHeight
                onAnimationStart={ this._scrollIntoView }
                onAnimationEnd={ this._scrollIntoView }
                duration={ 500 }
                active={ active }
                height={ "auto" }
            >
                { children }

            </AnimateHeight>

        </div>;
    }

}



// WEBPACK FOOTER //
// src/kiosk/ExpandableListItem/index.jsx